import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n";

export default function EditorialMarquee() {
  const { t } = useLang();
  return (
    <div data-testid="territory-marquee" className="overflow-hidden border-y border-champagne/25 bg-ivory py-7 md:py-9">
      <Marquee speed={26} gradient={false} pauseOnHover>
        {(t.marquee || []).map((place) => (
          <span key={place} className="flex items-center">
            <span className="whitespace-nowrap font-serif text-3xl font-light italic tracking-tight text-navy/80 md:text-5xl">
              {place}
            </span>
            <span className="mx-10 inline-block h-2 w-2 rotate-45 bg-champagne md:mx-14" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
